(() => {
  if (customElements.get('product-performance')) return;

  const SVG_NS = 'http://www.w3.org/2000/svg';
  const makeSvg = (name, attributes = {}) => {
    const node = document.createElementNS(SVG_NS, name);
    Object.entries(attributes).forEach(([key, value]) => node.setAttribute(key, String(value)));
    return node;
  };

  class ProductPerformance extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.draw();
    }

    draw() {
      const svg = this.querySelector('[data-performance-chart]');
      const metrics = [...this.querySelectorAll('[data-performance-metric]')].map((item, index) => {
        const indexText = String(index + 1).padStart(2, '0');
        const slot = item.querySelector('[data-performance-index]');
        if (slot) slot.textContent = indexText;
        return { value: Number(item.dataset.value), label: item.dataset.label, indexText };
      });
      if (!svg || !metrics.length) return;

      const center = 130;
      const radius = 88;
      const count = metrics.length;
      const point = (index, level, extra = 0) => {
        const angle = -Math.PI / 2 + Math.PI * 2 * index / count;
        const distance = radius * level / 5 + extra;
        return [center + Math.cos(angle) * distance, center + Math.sin(angle) * distance];
      };

      svg.replaceChildren();
      for (let level = 1; level <= 5; level += 1) {
        svg.append(makeSvg('circle', {
          class: 'as-performance__ring',
          cx: center,
          cy: center,
          r: radius * level / 5,
        }));
      }

      metrics.forEach((metric, index) => {
        const [axisX, axisY] = point(index, 5);
        svg.append(makeSvg('line', {
          class: 'as-performance__axis',
          x1: center,
          y1: center,
          x2: axisX,
          y2: axisY,
        }));
      });

      const valuePoints = metrics.map((metric, index) => point(index, metric.value));
      const shape = makeSvg(count > 2 ? 'polygon' : 'polyline', {
        class: 'as-performance__shape',
        points: valuePoints.map(([x, y]) => `${x},${y}`).join(' '),
      });
      svg.append(shape);

      valuePoints.forEach(([x, y], index) => {
        const node = makeSvg('circle', { class: 'as-performance__node', cx: x, cy: y, r: 3 });
        const title = makeSvg('title');
        title.textContent = `${metrics[index].label}: ${metrics[index].value} of 5`;
        node.append(title);
        svg.append(node);

        const [labelX, labelY] = point(index, 5, 15);
        const label = makeSvg('text', {
          class: 'as-performance__axis-index',
          x: labelX,
          y: labelY + 3,
        });
        label.textContent = metrics[index].indexText;
        svg.append(label);
      });

    }
  }

  customElements.define('product-performance', ProductPerformance);
})();
